import { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';

interface ProductDetailProps {
  id: number;
  name: string;
  description: string;
  image: string;
  details: string;
}

const ProductDetail = (): JSX.Element => {
  const { id } = useParams<{ id: string }>(); // 从 URL 中获取产品的 id
  const theme = useTheme();

  const [product, setProduct] = useState<ProductDetailProps | null>(null);

  const fetchProductDetail = () => {
    axios
      .get<ProductDetailProps>(`http://120.46.135.166:8000/products/${id}`, {
        headers: {
          Accept: 'application/json',
        },
      })
      .then((response) => {
        setProduct(response.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchProductDetail();
  }, [id]);

  if (!product) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        padding: theme.spacing(4),
        backgroundColor: theme.palette.background.default,
        minHeight: '100vh',
      }}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} md={8}>
          <Card
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              boxShadow: theme.shadows[3],
              borderRadius: 3,
            }}
          >
            {product.image && (
              <CardMedia
                component="img"
                sx={{ width: { md: '40%' }, height: 'auto' }}
                image={`http://120.46.135.166:8000${product.image}`} // 确保图片路径正确
                alt={product.name}
              />
            )}
            <CardContent sx={{ padding: theme.spacing(4), display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography variant="h4" gutterBottom align="center">
                {product.name}
              </Typography>
              <Typography variant="body1" color={theme.palette.text.secondary} paragraph align="center">
                {product.description}
              </Typography>
              <Typography variant="body2" color={theme.palette.text.secondary} align="center">
                {product.details}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProductDetail;
